import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import CustomTable from "@/shared/components/common/table";
import CustomButton from "@/shared/components/kit/button";
import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
/**
 * UserLoans
 *
 * نمایش وام‌های کاربر در فروشگاه و جزئیات اقساط.
 * این کامپوننت شامل:
 * - عنوان بخش و دکمه افزودن وام جدید
 * - دو جدول برای اقساط اعتبار داخلی و پولی پی 
 * - استفاده از toPersianNumber برای نمایش اعداد فارسی
 *
 * ویژگی‌های واکنش‌گرا:
 * - در موبایل، دکمه و عنوان در ستون قرار می‌گیرند
 * - جدول‌ها دارای overflow افقی در موبایل
 *
 * @returns JSX.Element
 */
const UserLoans = () => {
  const dataHeaderFirst = [
    { id: "rowId", title: "شناسه" },
    { id: "amount", title: "مبلغ وام (ریال)" },
    { id: "type", title: "اقساط باقی مانده" },
    { id: "merchant_name", title: "تاریخ خرید" },
    { id: "ts", title: "عملیات" },
  ];

  const fakeDataFirst: any = [];

  return (
    <CardKit sx={{ bgcolor: "#2C2C2C", width: "100%" }}>
      <StackKit gap={3} sx={{ width: "100%", textAlign: "right" }}>
        {/* Header & Button */}
        <StackKit direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} gap={2}>
          <TypoGraphyKit variant="body1">
            وام های کاربر در فروشگاه
          </TypoGraphyKit>
          <CustomButton sx={{ width: { xs: "100%", sm: "auto" } }}>
            <TypoGraphyKit variant="body1">وام جدید</TypoGraphyKit>
          </CustomButton>
        </StackKit>

        {/* Internal Credit Table */}
        <TypoGraphyKit variant="body1">اقساط اعتبار داخلی</TypoGraphyKit>
        <div style={{ overflowX: "auto" }}>
          <CustomTable dataHeader={dataHeaderFirst} dataTbody={fakeDataFirst} />
        </div>

        {/* 20 Card Credit Table */}
        <TypoGraphyKit variant="body1">{toPersianNumber("اقساط اعتبار پولی پی")}</TypoGraphyKit>
        <div style={{ overflowX: "auto" }}>
          <CustomTable dataHeader={dataHeaderFirst} dataTbody={fakeDataFirst} />
        </div>
      </StackKit>
    </CardKit>
  );
};

export default UserLoans;
